import { render, staticRenderFns } from "./InventionPicker.vue?vue&type=template&id=542f12e5&scoped=true&"
import script from "./InventionPicker.vue?vue&type=script&lang=js&"
export * from "./InventionPicker.vue?vue&type=script&lang=js&"
import style0 from "./InventionPicker.vue?vue&type=style&index=0&id=542f12e5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542f12e5",
  null
  
)

export default component.exports